module.exports = __webpack_public_path__ + "static/media/case3.3cfab8a1.jpg";